import { Box, Divider, Stack, Typography, Link } from '@mui/material';
import { NavLink, useNavigate } from 'react-router';
import SILOREAL_LOGO_BLACK from '../../assets/logos/siloreal-logo-black.webp';
import WhattsAppIcon from '@mui/icons-material/WhatsApp';
import i18n from '../../libs/language';

import MailIcon from '@old/assets/svg/domain/footer/mail-green.svg';
import WebIcon from '@old/assets/svg/domain/footer/globe-green.svg';
import MapPinIcon from '@old/assets/svg/core/location-pin-green.svg';

export function GlobalFooter({ hasMarginTop = true, backgroundColor = false }) {
  const navigate = useNavigate();

  const year = new Date().getFullYear();

  return (
    <>
      <Divider sx={{ marginTop: hasMarginTop ? '45px' : 0 }} />
      <Box
        width={'100%'}
        display={'flex'}
        flexDirection={'column'}
        padding={'20px 100px 45px 100px'}
        fontSize={'0.8rem'}
        gap={20}
        component="footer"
        sx={{
          backgroundColor: backgroundColor ? 'white' : undefined,
          padding: {
            xs: '20px 25px 45px 25px',
            sm: '20px 25px 45px 25px',
            md: '20px 50px 45px 50px',
            lg: '20px 100px 45px 100px',
          },
        }}
      >
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          display={'flex'}
          justifyContent={{ xs: 'center', md: 'space-between' }}
          alignItems={'center'}
          spacing={2}
        >
          <Stack direction={'column'}>
            <Box
              width={'100%'}
              marginRight={'auto'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <img
                style={{ width: 200, height: 75, objectFit: 'contain', cursor: 'pointer' }}
                src={SILOREAL_LOGO_BLACK}
                alt="SiloReal Company"
                onClick={() => navigate('/')}
              />
            </Box>{' '}
            <Typography color={'#7A7A7A'} alignItems={'start'}>
              {year} © SiloReal
            </Typography>
          </Stack>
          <Stack direction={'column'} spacing={2}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 2, md: 5 }}>
              <Stack spacing={2}>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ marginTop: '20px' }}>
                  <img style={{ width: 14, height: 14 }} src={MailIcon} />
                  <NavLink
                    to="#"
                    onClick={(e) => {
                      window.location.href = 'mailto:info@siloreal.com';
                      e.preventDefault();
                    }}
                    style={{
                      color: 'black',
                      textDecoration: 'none',
                    }}
                  >
                    <Box>info@siloreal.com</Box>
                  </NavLink>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <img style={{ width: 14, height: 14 }} src={WebIcon} />
                  <NavLink
                    to="https://siloreal.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: 'black',
                      textDecoration: 'none',
                    }}
                  >
                    <Box>siloreal.com</Box>
                  </NavLink>
                </Stack>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center" style={{ minWidth: 280 }} width={'100%'}>
                <img style={{ width: 22, height: 22 }} src={MapPinIcon} />
                <Stack>
                  <Box>Uruguay 2522,</Box>
                  <Box style={{ color: '#7A7A7A' }}>B1644 Beccar, Provincia de Buenos Aires, Argentina</Box>
                </Stack>
              </Stack>
            </Stack>

            <Stack
              direction={{ xs: 'column', md: 'row' }}
              spacing={2}
              display={'flex'}
              justifyContent={{ xs: 'center', md: 'end' }}
              alignItems={{ xs: 'center', md: 'end' }}
            >
              <Link
                style={{
                  color: '#6baa00',
                  fontWeight: 600,
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '4px',
                }}
                href="https://api.whatsapp.com/send/?phone=5491125928670&type=phone_number&app_absent=0"
                target="_blank"
              >
                <WhattsAppIcon sx={{ fontSize: 20 }} />
                {i18n.t('app.luna_whatsapp')}
              </Link>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </>
  );
}
